import {PHASES} from "../../../../constants/phases";
import {GAME_TYPES} from "../../../../constants/game";
import {
  selectIsMissionActive,
  selectIsTutorialActive,
  selectLobbyId,
  selectUserId
} from "../../../../redux/reducers/privateStateReducer/selectors";
import {checkIfCurrentUserTurn} from "../../user/checkIfCurrentUserTurn";

export const CONSTRUCTION_PLAN_CONTEXTS = {
  // Планировать нельзя, а оставшийся план не нужен
  NONE: 'none',
  // Идет чужой ход фазы строительства, а свой ход строительства у игрока в
  // этой фазе еще впереди: строения можно размечать в план
  PLANNING: 'planning',
  // Наступил собственный ход строительства: план применяется
  OWN_TURN: 'own_turn',
};

// Ключ хода строительства игрока — метка «план этого хода уже применен»
export const getConstructionPlanTurnKey = (round, playerId) => `${round}|${PHASES.CONSTRUCTION}|${playerId}`;

// Собственное место пользователя в партии. Ни зритель, ни админ за
// перехваченным ботом не планирует — только игрок за самого себя
export const getConstructionPlanPlayer = (state) => {
  const userId = selectUserId(state);
  const players = state?.shared?.gameState?.players || [];
  const player = userId ? players.find((candidate) => candidate.id === userId) : null;
  return player && !player.isBot ? player : null;
};

/**
 * Контекст плана строительства для пользователя: только сетевая партия
 * (обычная и рейтинговая), только фаза строительства, только собственное
 * место игрока, пока его ход строительства в этой фазе не завершен, и только
 * у игрока с городами: без них строить не из чего, и его ход строительства
 * сервер завершает сам (executePhaseAutoActions — тот же признак, города в
 * citiesCache по цвету игрока).
 */
export const getConstructionPlanContext = (state) => {
  const gameState = state?.shared?.gameState;
  if (!gameState || !gameState.isStarted || gameState.gameResults) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }
  if (gameState.gameType !== GAME_TYPES.ONLINE || !selectLobbyId(state)) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }
  if (selectIsTutorialActive(state) || selectIsMissionActive(state)) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }
  if (gameState.phase !== PHASES.CONSTRUCTION) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }

  const player = getConstructionPlanPlayer(state);
  if (!player || (gameState.phaseCompletedPlayers || []).includes(player.id)) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }
  if (((gameState.citiesCache || {})[player.color] || []).length === 0) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }

  const currentPlayer = (gameState.players || [])[gameState.currentPlayerIndex];
  if (!currentPlayer) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }

  // Ход бота, которым пользователь сейчас управляет вручную (перехват
  // управления админом), — это его ход в интерфейсе, а не чужой: план здесь
  // только спорил бы с настоящими действиями за бота
  if (currentPlayer.id !== player.id && checkIfCurrentUserTurn(gameState.gameType, player.id, currentPlayer)) {
    return CONSTRUCTION_PLAN_CONTEXTS.NONE;
  }

  return currentPlayer.id === player.id
    ? CONSTRUCTION_PLAN_CONTEXTS.OWN_TURN
    : CONSTRUCTION_PLAN_CONTEXTS.PLANNING;
};

export const checkIfConstructionPlanningAvailable = (state) =>
  getConstructionPlanContext(state) === CONSTRUCTION_PLAN_CONTEXTS.PLANNING;
